export default {
  invoice: "Invoice",
  invoiceSettings: "Invoice Settings",
  defaultTerms: {
    label: "Default Invoice Terms",
    help: "Shown on every new invoice unless overridden. Appears in the PDF and the invoice email.",
    saved: "Default invoice terms saved.",
  },
};
